import React from 'react';
import './TermsAndConditions.css';

const CoachJoinTerms = () => {
    return (
        <div className="ip-terms-container">
            <h1 className="ip-terms-title">Agreement to Our Terms and Conditions</h1>
            <p className="ip-updated-date">Last Updated 14/01/2025</p>
            <p className="ip-terms-section-content">
                We are The Ideal Pursuits (“Company”, “we”, “us”, “our”)
            </p>

            <div className="ip-terms-section">
                <h2 className="ip-terms-section-title">Terms and Conditions</h2>
                <ol className="ip-terms-section-content">
                    <li>All conversations/discussions/exchange of information must solely within the parameters of providing educational and career upskilling consultation.</li>
                    <li>Any further and/or new session in continuation of the earlier session must be made only through the Service portal in the usual manner prescribed.</li>
                    <li>Any suggestions related to acquiring a skill related to career in terms of courses or college is subjected to personal choice of the user. The company will not be held accountable for any damage or losses.</li>
                    <li>No guarantees will be given in terms of job or assured success in career. Only opinionated methodology to be adopted which provides service.</li>
                    <li>During video calls complete professionalism, decorum to be maintained. Any violation stipulated as per the terms and conditions set forth herein will lead to immediate termination of the session and profile of the user will be deactivated, and there shall be no re-payment of dues, if any.</li>
                    <li>Users are expected to maintain the highest standards of professionalism and decorum during video consultations with experts. Any conduct that contravenes legal or ethical boundaries, or attracts penal consequences, will be addressed appropriately, including reporting to the relevant legal authorities if required.</li>
                    <li>You will not use the services for any illegal and unauthorized purpose and your use of services should not violate any applicable law or regulation.</li>
                </ol>
            </div>
            
            <p className="ip-terms-section-content">
                You can contact us by email at <a href="mailto:Saranraj@Idealpursuits.co.in">Saranraj@Idealpursuits.co.in</a>
            </p>
        </div>
    );
};

export default CoachJoinTerms;
